import { withStyles, Grid, Typography, Paper } from '@material-ui/core';
import React from 'react'; // eslint-disable-line
import styles, { StyledComponent } from '../../../../../styles/styles';
import { LabeledValue } from '../../../../../controls/labeled-value';
import { connect } from 'react-redux';
import { State } from '../../../../../redux/root-reducer';
import { FormDetails, getFormDetails } from '../form-details-reducer';
import { getDisplayDate } from '../../../../../shared-functions';

interface BaseProps {
    formDetails?: FormDetails;
}

interface Props extends BaseProps, StyledComponent {}

const occupationalDisabilityOverHeadView: React.FunctionComponent<Props> = ({
    classes,
    formDetails,
}: Props) => {
    const occupationalDisabilityOverheadOne =
        formDetails?.claimInformation?.occupationalDisabilityOverheadOne;

    return (
        <React.Fragment>
            <Grid container justify="space-between" className={classes.marginTop2}>
                <Grid container item xs={12} alignItems="center">
                    <Typography style={{ padding: 10 }} className={classes.heading} variant="body1">
                        Occupational Disability and Overhead Expenses Benefit Claims
                    </Typography>
                </Grid>
            </Grid>
            <Paper className={classes.paper}>
                <Grid container justify="flex-start">
                    <Grid item xs={12} container justify="flex-start">
                        <Grid item xs={6} lg={6}>
                            <LabeledValue
                                label="Name of current or previous employer"
                                value={
                                    occupationalDisabilityOverheadOne?.nameOfCurrentOrPreviousEmployer
                                }
                            />
                        </Grid>

                        <Grid item xs={6} lg={6}>
                            <LabeledValue
                                label="Address"
                                value={`${occupationalDisabilityOverheadOne?.address} ${'\n'} ${
                                    occupationalDisabilityOverheadOne?.postalCode
                                }`}
                            />
                        </Grid>
                        <Grid item xs={6} lg={6}>
                            <LabeledValue
                                label="Date Employed From"
                                value={getDisplayDate(
                                    occupationalDisabilityOverheadOne?.dateEmployedFrom
                                )}
                            />
                        </Grid>
                        <Grid item xs={6} lg={6}>
                            <LabeledValue
                                label="Date Employed To"
                                value={getDisplayDate(
                                    occupationalDisabilityOverheadOne?.dateEmployedTo
                                )}
                            />
                        </Grid>
                        <Grid item xs={6} lg={6}>
                            <LabeledValue
                                label="What was your full time occupation immediately before your current disability began?"
                                value={
                                    occupationalDisabilityOverheadOne?.whatWasYourFullTimeOccupationImmediatelyBeforeYourCurrentDisabilityBegan
                                }
                            />
                        </Grid>
                        <Grid item xs={6} lg={6}>
                            <LabeledValue
                                label="Please provide a breakdown of your duties i.e 80% of your work was in an office environment"
                                value={`${
                                    'Administrative:' +
                                    occupationalDisabilityOverheadOne?.administrative +
                                    '%'
                                } ${'\n'} ${
                                    'Supervisory within an office environment:' +
                                    occupationalDisabilityOverheadOne?.supervisoryWithinAnOfficeEnvironment +
                                    '%'
                                }  ${'\n'} ${
                                    'Supervisory within a non-office environment:' +
                                    occupationalDisabilityOverheadOne?.supervisoryWithinANonOfficeEnvironment +
                                    '%'
                                }
                                                                        ${'\n'} ${
                                    'Travel:' + occupationalDisabilityOverheadOne?.travel + '%'
                                }
                                                                        ${'\n'} ${
                                    'Light Manual Work:' +
                                    occupationalDisabilityOverheadOne?.lightManualWork +
                                    '%'
                                }
                                                                      ${'\n'} ${
                                    'Heavy Manual Work:' +
                                    occupationalDisabilityOverheadOne?.heavyManualWork +
                                    '%'
                                }`}
                            />
                        </Grid>
                        <Grid item xs={6} lg={6}>
                            <LabeledValue
                                label="Please provide an accurate description of the exact nature and duties of your full time occupation (job description)"
                                value={
                                    occupationalDisabilityOverheadOne?.whatWasYourFullTimeOccupationImmediatelyBeforeYourCurrentDisabilityBegan
                                }
                            />
                        </Grid>
                        <Grid item xs={6} lg={6}>
                            <LabeledValue
                                label="Is there any hazard associated with your occupation? (e.g mining, asbestos, handling of explosives etc)"
                                value={
                                    occupationalDisabilityOverheadOne?.isThereAnyHazardAssociatedWithYourOccupation
                                }
                            />
                        </Grid>
                        {occupationalDisabilityOverheadOne?.isThereAnyHazardAssociatedWithYourOccupation ===
                            'Yes' && (
                            <Grid item xs={6} lg={6}>
                                <LabeledValue
                                    label="Please provide details of any hazards"
                                    value={
                                        occupationalDisabilityOverheadOne?.pleaseProvideDetailsOfAnyHazards
                                    }
                                />
                            </Grid>
                        )}
                        <Grid item xs={6} lg={6}>
                            <LabeledValue
                                label="Do you travel beyond the borders of South Africa in the course of your duties?"
                                value={
                                    occupationalDisabilityOverheadOne?.doYouTravelBeyondTheBordersOfSouthAfricaInTheCourseOfYourDuties
                                }
                            />
                        </Grid>
                        {occupationalDisabilityOverheadOne?.isThereAnyHazardAssociatedWithYourOccupation ===
                            'Yes' && (
                            <Grid item xs={6} lg={6}>
                                <LabeledValue
                                    label="Please specify the countries that you travel to and the nature of your duties in those countries"
                                    value={
                                        occupationalDisabilityOverheadOne?.pleaseSpecifyTheCountriesThatYouTravelToAndTheNatureOfYourDutiesInThoseCountries
                                    }
                                />
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    );
};

const mapStateToProps = (state: State, ownProps: BaseProps) => ({
    formDetails: ownProps.formDetails ?? getFormDetails(state),
});

const mapDispatchToProps = {};

export const OccupationalDisabilityOverHeadView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(occupationalDisabilityOverHeadView));
